import { getGroupedServiceOffer } from './GroupedServiceOfferView'

import { LocalizedGroupServiceOfferView, TargetLanguage } from '../../contracts/service-offer'
import { asBuilder } from '../asBuilder'

const builder = asBuilder(getGroupedServiceOffer)

export const getLocalizedGroupServiceOfferView = asBuilder((): LocalizedGroupServiceOfferView => {
  const groupedServiceOfferView = builder()
  return {
    ...groupedServiceOfferView,
    groupedServiceOffers: Object.values(TargetLanguage).map((targetLanguage) => ({
      ...groupedServiceOfferView,
      targetLanguage,
    })),
  }
})
